import {historyToDataLayer} from '../analytics/ga_events'
import {setupNextStep} from '../main_form'
import {validate} from './triggers_and_progressbar'
import {newRedirectPopup} from './redirectPopup'

function detectmob() {
  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}

function detectDevice() {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android'
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return 'BlackBerry'
  } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    return 'iOS'
  } else if (navigator.userAgent.match(/Macintosh/i)) {
    return 'MacOS'
  } else if (navigator.userAgent.match(/IEMobile/i)) {
    return 'WindowsPhone'
  } else {
    return 'Desktop'
  }
}

function swapDict(json) {
  let ret = {};
  for (let key in json) {
    ret[json[key]] = key;
  }
  return ret;
}

function GetURLParameter(sParam, url) {
  let sPageURL = (!url ? window.location.search.substring(1) : url);
  let sURLVariables = sPageURL.split('&'),
    firstUrlvar = sPageURL.split('?');
  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }
  for (let i = 0; i < firstUrlvar.length; i++) {
    let sParameterName = firstUrlvar[i].split('=');
    if (sParameterName[0] == sParam) {
      return sParameterName[1].replace(/&\w+/gi, '');
    }
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function mergeDeep(target, source) {
  const isObject = (obj) => obj && typeof obj === 'object';

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(key => {
    const targetValue = target[key];
    const sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });

  return target;
}

function hubEvent(lead_id, state_type, token, additional) {
  let params = {
    'lead_id': lead_id,
    'state_type': state_type,
    'token': token
  }
  if (additional) params = {...params, ...additional}
  $.ajax({
    url: globalConfig.backendurl + '/webhook',
    type: 'post',
    dataType: 'json',
    data: params,
    success: function (data) {
      console.log('hub event sended:', data)
    }
  });
}

window.hubEvent = hubEvent

function getAge(dateString) {
  dateString = dateString.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1")
  let today = new Date();
  let birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  console.log(`Customer age: ${age}`)
  return age;
}

function updateFirebaseTokenWithLeadId() {
  let currentToken = localStorage.getItem('sentFirebaseMessagingToken')
  if (currentToken && !localStorage.getItem('updatedFirebaseMessagingToken'))
    $.ajax({
      url: `${globalConfig.backendurl}/set-token`,
      type: 'post',
      dataType: 'json',
      data: {
        token: currentToken,
        ga_client_id: $('#ga_client_id').val(),
        domain: window.location.hostname,
        lead_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id'),
        country: $("[name=country]").val(),
        provider: $("[name=provider]").val()
      },
      success: function (data) {
        localStorage.setItem('updatedFirebaseMessagingToken', currentToken)
      },
      error: function (e) {
        console.warn('update token is unsuccessfull')
      }
    })
}

function mGidLead() {
  let d = document, w = window;
  w.MgSensorData = w.MgSensorData || [];
  w.MgSensorData.push({cid: 473462, lng: "us", nosafari: true, project: "a.mgid.com"});
  let l = "a.mgid.com";
  let n = d.getElementsByTagName("script")[0];
  let s = d.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  let dt = !Date.now ? new Date().valueOf() : Date.now();
  s.src = "//" + l + "/mgsensor.js?d=" + dt;
  n.parentNode.insertBefore(s, n);
}

function redirectSwitch(res, country) {
  let isLender = function (lender) {
    return res.redirect_url.indexOf(lender) > -1
  }
  // if (isLender('twinero.es')) {
  //   localStorage.setItem('twinero_redirect_url', res.redirect_url);
  //   $('[name=confirm]').closest('.ui-form__row').prev('.field_label-text').addClass('hidden');
  //   setupNextStep(["twinero_instantor"], res.lead_id)
  // } else
  if (isLender('dispon.es')) {
    formPostRedirect(res.redirect_url, ['username', 'password'])
  } else {
    if (country.is_ES) {
      let esParams = {
        header: '¡Tu solicitud ha sido aceptada!',
        subheader: 'Serás redirigido al sitio web de la entidad financiera, que ha aceptado la solicitud, en 5 segundos.',
        button: 'Haz clic para continuar.',
        timeout: 5000,
        amountHint: 'Monto del préstamo solicitado',
        amount: res.loan_sum,
        currency: '€'
      }
      // customization for Creditosi
      if (+res.lender_id === 187) {
        esParams.header = 'Felicidades! ¡CreditoSi ha preaprobado tu préstamo!'
        esParams.subheader = 'Serás redirigido a su web para verificar tu teléfono móvil y añadir tu banca electrónica.  Estos son los costes finales:'
        esParams.button = 'Haz click para aceptar y continuar'
        esParams.amountHint = 'Importe aprobado'
        esParams.amountAdditional = [
          { label: 'Intereses', value: '€' + (+res.loan_sum * 0.25).toFixed(0) },
          { label: 'Apertura', value: '€' + (+res.loan_sum * 0.1).toFixed(0) }
        ]
        // esParams.additionalText = 'Estimado Cliente, Te informamos que estás siendo redirigido a la empresa CreditoSi, la cual va a verificar tu solicitud de préstamo. Por favor, ten en cuenta que CreditoSi puede aplicar gastos adicionales. Todos los costes se verán reflejados en el último paso de tu solicitud.'
      }
      // customization for fidinda
      if (+res.lender_id === 327) {
        esParams.period = `${res.loan_period} días`
        esParams.periodHint = 'Período'
      }
      // customization for Mycredit
      if (+res.lender_id === 116) {
        console.log('simple redirect for Mycredit')
        simpleRedirect(res.redirect_url)
        return
      }
      newRedirectPopup('',
        `${res.logo_url}`,
        `${res.redirect_url}`,
        esParams
      )
    } else {
      simpleRedirect(res.redirect_url)
    }
  }
}

function successRedirectPrepare() {
  window.onbeforeunload = null;
  window.is_redirected = true;
  formFillingHistoryStatus = 'formFillingHistorySuccess'
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'formFillingHistorySuccess',
    'eventCategory': 'Form Filling',
    'eventAction': JSON.stringify(historyToDataLayer),
    'lead_id': localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  });
}

function processIframeRedirect(url) {
  $('.box-wrapper').addClass('hidden');
  $('.iframe-redirector').removeClass('hidden');
  $('#iframe-redirector-button').attr('href', url)
}

function proceedRedirect(url) {
  successRedirectPrepare()
  function OpenInNewTabWinBrowser(url) {
    // redirect to new url in new tab
    try {
      new_tab_win = window.open(url, '_blank');
      new_tab_win.focus();
      const leadId =  localStorage.getItem('leadId') || localStorage.getItem('lead_id')
      let externalUuid = leadId ? ('&sub1=' + leadId.split('-').join('')) : ''
      if (!is_iframe) {
        // window.location.href = ((Math.random() >= 0.5) ? '/offers?sub2=feed-api' : '/feed2?sub2=feed-api-nml')
        window.location.href = '/offers?sub2=feed-api' + externalUuid
      } else {
        window.location.href = '/iframe/offers?sub2=feed-api' + externalUuid
      }
      console.log('REDIRECT SUCCESS')
    } catch (e) {
      // if browser block new tab - open in this tab
      console.log(e, 'REDIRECT IN NEW TAB ERROR')
      if (!is_iframe) {
        window.location.href = url
      } else {
        processIframeRedirect(url)
      }
      // need button for iframe redirect main window
    }
  }

  if (detectDevice() != "Apple") {
    OpenInNewTabWinBrowser(url)
  } else {
    if (!is_iframe) {
      window.location.href = url
    } else {
      processIframeRedirect(url)
    }
    // need button for iframe redirect main window
  }
}

function simpleRedirect(url) {
  successRedirectPrepare()
  if (!is_iframe) {
    window.location.href = url
  } else {
    processIframeRedirect(url)
  }
}

function formPostRedirect(url, params) {
  successRedirectPrepare()
  console.log('post redirect to:', url)
  let fields = ''
  for (let i in params) {
    fields += `<input type="text" name="${params[i]}" value="${GetURLParameter(params[i], url)}" />`
  }
  let form = $(`<form action="${url}" method="post">${fields}</form>`)
  $('body').append(form);
  form.submit();
}

function hardRefreshPage() {
  let varsToClear = ['auth_token', 'JWTAutocomplete', 'AuthAutocomplete', 'leadId', 'lead_id']
  for (let i in varsToClear) {
    localStorage.removeItem(varsToClear[i])
  }
  window.onbeforeunload = null;
  window.is_redirected = true;
  if (!is_iframe) {
    window.location.href = '/reg';
  } else {
    window.location.href = '/iframe/offers';
  }
}

function pushFBEvent(track, event, data) {
  try {
    if (window.fbq) fbq(track, event, data)
  } catch (e) {
    console.warn(e)
  }
}

function pushVKEvent(event, data) {
  let VK = window.VK || {
    Goal: () => {
    }
  }
  if (data) {
    VK.Goal(event, data)
  } else {
    VK.Goal(event)
  }
}

function pushGTMEvent(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data)

  if (data.event === 'FirstStepSubmitted') {
    // init cc pixel (concat leads between sites)
    ccIframeInit()
    try {
      if (window.ttq) window.ttq.track('SubmitForm', {}, { event_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id') })
    } catch (e) {}
    try {
      $.ajax({
        url: 'https://events.crezu.net/api/event',
        type: 'post',
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({
          event_id: 3,
          sub1: GetURLParameter('lead_id') || localStorage.getItem('leadId'),
          sub2: GetURLParameter('exp_flow') || 0,
          provider_id: +$("[name=provider]").val(),
          session_id: getCookie('uuidv4') || generateUUIDv4(),
          domain: window.location.hostname,
          utm_source: GetURLParameter('utm_source') || window.sbjs.get.current.src,
          utm_medium: GetURLParameter('utm_medium') || window.sbjs.get.current.mdm,
          utm_campaign: GetURLParameter('utm_campaign') || window.sbjs.get.current.cmp,
          utm_content: GetURLParameter('utm_content') || window.sbjs.get.current.cnt,
          utm_term: GetURLParameter('utm_term') || window.sbjs.get.current.trm
        }),
        error: function(error) {
          console.error('event error:', error)
        }
      })
    } catch (e) {}
  }
}

function setLeadId(leadId) {
  localStorage.setItem('leadId', leadId);
  localStorage.setItem('lead_id', leadId);
  dispatchCrezuEvent('leadCreated', {'leadId': leadId})
}

function dispatchCrezuEvent(name, data) {
  const event = new CustomEvent(name, {'detail': data})
  window.dispatchEvent(event)
}

function getDPI() {
  try {
    for (var i = 56; i < 2000; i++) {
      if (matchMedia("(max-resolution: " + i + "dpi)").matches === true) {
        return i
      }
    }
    return i
  } catch (e) {
    return 0
  }
}

function getScreenSize() {
  try {
    var dppx = window.devicePixelRatio ||
      (window.matchMedia && window.matchMedia("(min-resolution: 2dppx), (-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5)").matches ? 2 : 1) || 1;
    return `${screen.width * dppx}x${screen.height * dppx}`
  } catch (e) {
    return 0
  }
}

function enableOptionalField(field) {
  $('[name=' + field + ']').prop('disabled', false).closest('.ui-form__row').removeClass('hidden');
  if (step_required_fields.indexOf(field) == -1)
    step_required_fields.push(field)
}

function disableOptionalField(field) {
  $('[name=' + field + ']').prop('disabled', true).closest('.ui-form__row').addClass('hidden');
  if (step_required_fields.indexOf(field) > -1)
    step_required_fields.splice(step_required_fields.indexOf(field), 1)
}

function beforeUnloadListener() {
  const leadId =  localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  if (step_required_fields.indexOf("id_number") > -1) {
    pushGTMEvent({
      "event": "TimeSecondStepDropped",
      "value": (Date.now() / 1000 | 0) - formFillStart,
      "lead_id": leadId
    })
  }
  if (formFillingHistoryStatus === 'formFillingHistoryDropped') {
    pushGTMEvent({
      'event': 'formFillingHistoryDropped',
      'eventCategory': 'Form Filling',
      'eventAction': JSON.stringify(historyToDataLayer),
      'lead_id': leadId
    })
  }
  if (window.curr_step > 1 && formFillingHistoryStatus !== 'formFillingHistorySuccess') {
    hubEvent(leadId, 'dropped_2_step', localStorage.getItem('sentFirebaseMessagingToken'))
  }
  if (window.curr_step === 1 && formFillingHistoryStatus !== 'formFillingHistorySuccess' && leadId) {
    hubEvent(leadId, 'site_open', localStorage.getItem('sentFirebaseMessagingToken'))
  }
  let droppedEmail = $('[name=email]')
  if (window.curr_step === 1 && droppedEmail.val() && validate(droppedEmail) && !leadId && !getCookie('abandoned_application')) {
    setCookie('abandoned_application', 1, 1)
    hubEvent(null, 'abandoned_application', localStorage.getItem('sentFirebaseMessagingToken'), { email: droppedEmail.val(), country_id: $('[name=country]').val() })
  }
}

function initUTM() {
  const utmSplitter = (data) => {
    if (!data || typeof data !== 'string') return data
    return data.split(',')[0]
  }

  $('#utm_source').val(GetURLParameter('utm_source') || utmSplitter(sbjs.get.current.src));
  $('#utm_medium').val(GetURLParameter('utm_medium') || utmSplitter(sbjs.get.current.mdm));
  $('#utm_campaign').val(GetURLParameter('utm_campaign') || utmSplitter(sbjs.get.current.cmp));
  $('#utm_content').val(GetURLParameter('utm_content') || utmSplitter(sbjs.get.current.cnt));
  $('#utm_term').val(GetURLParameter('utm_term') || utmSplitter(sbjs.get.current.trm));
  $('#gclid').val(GetURLParameter('gclid') || getCookie('gclid') || '');

  setTimeout(function () {
    if (typeof (ga) != 'undefined')
      ga(function () {
        var trackers = ga.getAll();
        if (trackers) $('#ga_client_id').val(trackers[0].get('clientId'))
      });
  }, 100);
}

function updateInputsDataFromURL() {
  let amount = GetURLParameter('amount'),
      days = GetURLParameter('days'),
      name_url = GetURLParameter('name'),
      surname_url = GetURLParameter('surname'),
      email_url = GetURLParameter('email'),
      phone_url = GetURLParameter('phone'),
      ar_phone_code_url = GetURLParameter('ar-phone-code'),
      ar_phone_url = GetURLParameter('ar-phone');
    if (localStorage.getItem('dataFromFirstStep')) {
      var lsData = JSON.parse(localStorage.getItem('dataFromFirstStep'))
      amount = amount ? amount : lsData['amount']
      days = days ? days : lsData['days']
      name_url = name_url ? name_url : lsData['name']
      surname_url = surname_url ? surname_url : lsData['surname']
      email_url = email_url ? email_url : lsData['email']
      phone_url = phone_url ? phone_url : lsData['phone']
      ar_phone_code_url = ar_phone_code_url ? ar_phone_code_url : lsData['ar-phone-code']
      ar_phone_url = ar_phone_url ? ar_phone_url : lsData['ar-phone']
    }
    if (days && days > 0) {
      $('[name=loan_period]').val(days).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=loan_period]'));
    }
    if (amount && amount > 0) {
      $('[name=loan_sum]').val(amount).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=loan_sum]'));
    }
    if (name_url && name_url != '') {
      $('[name=name]').val(decodeURI(name_url)).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=name]'));
    }
    if (surname_url && surname_url != '') {
      $('[name=surname]').val(decodeURI(surname_url)).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=surname]'));
    }
    if (email_url && email_url != '') {
      $('[name=email]').val(email_url).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=email]'));
    }
    if (ar_phone_code_url && ar_phone_code_url != '') {
      $('[name=ar-phone-code]').val(ar_phone_code_url).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=ar-phone-code]'));
    }
    if (ar_phone_url && ar_phone_url != '') {
      $('[name=ar-phone]').val(ar_phone_url).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=ar-phone]'));
    }
    if (phone_url && phone_url != '') {
      $('[name=phone]').val(phone_url).addClass('ui-input__field_not-empty').trigger('blur');
      validate($('[name=phone]'));
      setTimeout(function () {
        $('[name=phone]').trigger('keyup');
      }, 100)
    }
}

function ccIframeInit () {
  let a = 'cc_iframe'
  let b = document.createElement('iframe')
  b.id = a
  document.body.appendChild(b)
  document.getElementById(a).style.display = 'none'
  let li = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  let ts = +new Date()
  document.getElementById(a).src = 'https://clicfin.com/?li=' + li + '&ts=' + ts
}

export {
  detectDevice,
  detectmob,
  swapDict,
  GetURLParameter,
  getCookie,
  setCookie,
  mergeDeep,
  hubEvent,
  getAge,
  updateFirebaseTokenWithLeadId,
  mGidLead,
  proceedRedirect,
  simpleRedirect,
  processIframeRedirect,
  successRedirectPrepare,
  redirectSwitch,
  hardRefreshPage,
  pushFBEvent,
  pushGTMEvent,
  pushVKEvent,
  setLeadId,
  getDPI,
  getScreenSize,
  dispatchCrezuEvent,
  enableOptionalField,
  disableOptionalField,
  beforeUnloadListener,
  initUTM,
  updateInputsDataFromURL
}
